module.exports = "<list-view\n  title=\"Packages\"\n  transformer=\"PackagesTransforms\"\n  item-state=\"package\"\n  resource=\"Packages\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  sort-event=\"$ctrl.sortEvent\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  filter-event=\"$ctrl.filterEvent\"\n  page=\"$ctrl.page\"\n  limit=\"$ctrl.limit\"\n  no-items-text=\"No Packages Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\"> </main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/packages/packages.html
// module id = 2019
// module chunks = 0